
import { useNavigate } from 'react-router-dom'
import { useHighlightedAnnouncements } from '@/lib/api/hooks/announcement'
import { stripHtml } from '@/utils/helpers/html'
import Heading from '@/components/ui/Typography/Heading'
import { Text } from '@/components/ui/Typography'

interface AnnouncementSectionProps {
  className?: string
}

const CONTENT_CATEGORY_ROUTES: Record<string, string> = {
  EVENT: '/events',
  PRESS_RELEASE: '/media/press-release',
  PROGRAMME: '/programmes/programs',
  STRATEGIC_PILLAR: '/programmes/strategic-pillars'
}

const getContentRoute = (baseRoute: string, contentId: string | null, category: string): string | null => {
  if (!baseRoute || !contentId || !category) return "/events"
  
  return `${baseRoute}/${contentId}`
}

const AnnouncementSection = ({ className }: AnnouncementSectionProps) => {
  const navigate = useNavigate()
  const { data } = useHighlightedAnnouncements()

  const highlightedAnnouncement = data?.data ?? null
  const hasAnnouncement = !!highlightedAnnouncement

  const announcementTitle = highlightedAnnouncement?.linkedContentId ? highlightedAnnouncement?.linkedContent?.title : highlightedAnnouncement?.title ?? ''
  const announcementDescription = highlightedAnnouncement?.linkedContent ? highlightedAnnouncement?.linkedContent?.content : highlightedAnnouncement?.description ? highlightedAnnouncement.description : 
    'There is currently no highlighted announcement available. Please check back later for updates on our latest news and programmes.'
  const announcementImage = highlightedAnnouncement?.linkedContent?.imageUrl ? highlightedAnnouncement.linkedContent.imageUrl : highlightedAnnouncement?.imageUrl ? highlightedAnnouncement.imageUrl : 
    'https://res.cloudinary.com/dlwegkhme/image/upload/v1755760291/5203ea7a5ce3287cbc982b11bc058479465aa367_t0ojk9.png'
  const ctaRoute = highlightedAnnouncement?.contentCategory
    ? getContentRoute(CONTENT_CATEGORY_ROUTES[highlightedAnnouncement.contentCategory], highlightedAnnouncement.linkedContentId, highlightedAnnouncement.contentCategory) ?? '/events'
    : '/events'
  const ctaLabel = hasAnnouncement ? 'Learn more' : 'See Events'
  
  return (
    <section className={`md:py-16 bg-white ${className}`} aria-labelledby="announcement-section-title">
      <div className="max-w-[1440px] mx-auto space-y-4 px-4 sm:px-6 lg:px-8">
         <Heading level={3} className=" ">
            Announcement
          </Heading>
    <section className={`grid gap-4 md:gap-0 md:grid-cols-2`}>
      {/* Background Image */}
      <div className="">
        <img
          src={announcementImage}
          alt="African Space Agency Building"
          className="w-full h-full aspect-video object-cover"
        />
      </div>


      {/* Content */}
      <div className="bg-wine-100 flex  p-4 sm:p-6 lg:p-8 xl:p-12 w-full flex-col justify-center gap-6 md:gap-8 xl:gap-12">
            <Heading level={3} className=" text-white ">
              {announcementTitle}
            </Heading>
            
            <Text className=" md:text-lg text-white  line-clamp-3 ">
              {stripHtml(announcementDescription)}
            </Text>

            <button 
              onClick={() => navigate(ctaRoute)}
              className="inline-flex items-center px-8  py-2.5 md:py-4 bg-wine-200 w-fit hover:bg-wine-200 text-white font-semibold font-satoshi rounded-sm transition-all duration-300 transform hover:scale-105 shadow-lg"
              aria-label={ctaLabel}
            >
              {ctaLabel}
            </button>
        
      </div>

    </section>
    </div>
    </section>
  )
}

export default AnnouncementSection